import create from 'zustand'
import store from '../store'
import { State } from '../store/types'
import { API } from './types'

type Condition = {
  validation: boolean
  info: string
}

type Params = {
  options: API.QueryOptions
  conditions: Condition[]
}

const useBlockQuery = ({ options, conditions }: Params) => {
  const useStore = create<State>(store)

  const { token, target } = useStore()

  const isProtectedRequest = conditions.find((x) => !!x?.validation)

  /**
   * This will stop the query if any of the protected conditions are met and
   * there is no authentication token
   */

  const canEnableQuery = isProtectedRequest?.validation ? !!token : true

  if (target === 'staging' && !canEnableQuery) {
    console.warn(`[API Consumer] Request blocked

Showing ${isProtectedRequest.info} is restricted to authenticated memberships. Sign-in to unlock this request.

You can check the current state of this query by using "isIdle" property to render an alternative UI.
`)
  }

  const enabled = [...(options?.enabled || []), !!canEnableQuery]

  return { ...options, enabled }
}

export default useBlockQuery
